// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import DynamicComponent from '@tcp/core/src/components/common/atoms/DynamicTag';
/* THIS COMPONENT HAS BEEN DEPRECATED AND WILL BE REMOVED ON FUTURE RELEASE */
const HeadingStyle = (props) => <DynamicComponent {...props} />;
const BodyStyle = (props) => <DynamicComponent {...props} />;
export { HeadingStyle, BodyStyle };
